<template>
    <div class="container-review">
        <div v-if="reviewStatus">
            <div class="img-logo " style="visibility:hidden"></div>
            <VTextMarquee :speed="showSpeed" class="wrapper-marquee" ref="marquee">
                <div class="wrapper-marquee-content">
                    <div v-for="(data, index) in reviewData[currentIndex]" :key="`review${index}`"
                         class="wrapper-content">
                        <div class="header-content">
                            <div class="img-profile"
                                 :style="`background-image: url(${returnUserProfile(data.mb_profile,returnFile(data),{w:36,h:36})})`"></div>
                            {{ data.mb_nick }}
                        </div>
                        <div class="body-content">
                            {{ data.wr_content }}
                        </div>
                    </div>
                </div>
            </VTextMarquee>
        </div>

        <div class="empty-wrap" v-else>
            등록된 후기가 없습니다.
        </div>

        <div class="text-bottom">
            <div class="img-left"></div>
            <div class="img-right"></div>
            우리 친구들의 후기를 확인해볼까?
        </div>

    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import {VTextMarquee} from 'vue-text-marquee';
import util from "@/mixins/util";

let reviewInterval = null;
let showSetTimeout = null;
import memberMixins from "@/mixins/memberMixins";

export default {
    name: "ReviewComponent",
    mixins: [alertMixins, memberMixins],
    components: {VTextMarquee},
    inject: [],
    provide() {
        return {}
    },
    props: {
        memberKey: 0,
    },
    data() {
        return {
            reviewData: [],
            showSpeed: 150,
            nowKey: '',
            currentIndex: 0,
            allReviewData: [],
            firstShow: false,
            reviewStatus: false,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.getReview();
        reviewInterval = setInterval(function () {
            this.getReview();
        }.bind(this), 5000);
        this.checkShowData()

    },
    beforeDestroy() {
    },
    destroyed() {
        if (reviewInterval) {
            clearInterval(reviewInterval);
        }
        if (showSetTimeout) {
            clearTimeout(showSetTimeout);
        }
    },
    computed: {},
    methods: {
        getReview() {
            let params = {
                ip: 0,
                pid: this.memberKey,
            };
            if (util.isEmpty(this.nowKey)) {
                params.crsd = this.$moment().format(`YYYY-MM-DD`)
            } else {
                params.wrid = this.nowKey;
            }

            EventBus.$emit('changeLoading', true);
            try {
                this.$api.$board.getReview(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type !== 1) {
                        this.errorAlert('데이터를 불러올 수 없습니다.');
                        this.$router.back();
                        EventBus.$emit('changeLoading', false);
                        return false;
                    }
                    this.makeArr(res.List)
                    EventBus.$emit('changeLoading', false);
                })
            } catch (e) {
                console.log(e);
                EventBus.$emit('changeLoading', false);
            }
        },
        makeArr(pushArr) {
            this.allReviewData = this.allReviewData.concat(pushArr);

            let makeData = this.$_.chunk(this.allReviewData, 10);
            this.reviewData = makeData;

            if (pushArr.length > 0) {
                let lastArr = pushArr[pushArr.length - 1];
                this.nowKey = lastArr.wr_id;
            }

            if (!util.isEmpty(this.reviewData[0]) && this.reviewData[0].length > 9) {
                this.reviewStatus = true;
            }
        },

        returnFile(data) {
            if (!util.isEmpty(data.Files)) {
                return data.Files[0]
            }
            return [];
        },
        checkShowData() {
            if (showSetTimeout) {
                clearTimeout(showSetTimeout);
            }
            if (util.isEmpty(this.$refs.marquee)) {
                showSetTimeout = setTimeout(() => {
                    this.checkShowData();
                }, 500)
                return
            }

            if (this.reviewData[this.currentIndex].length > 9 && !util.isEmpty(this.reviewData[this.currentIndex + 1]) && this.reviewData[this.currentIndex + 1].length > 9 && this.firstShow) {
                this.showSpeed = 150;
                this.currentIndex = this.currentIndex + 1;
            }
            this.firstShow = true;

            showSetTimeout = setTimeout(() => {
                this.checkShowData();
            }, 31600)
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
